var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('employ-edit',{attrs:{"row":_vm.row,"opType":"self","company-id":_vm.$store.getters.userInfo.companyId,"isReadOnly":_vm.formReadonly,"canAdd":false},on:{"close":_vm.close,"update":_vm.update,"updatePartialEmployeeInfo":_vm.updatePartialEmployeeInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }